import React, { PureComponent } from 'react'
import { Button, Form, Message, Modal } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom'
import { login, notAuthenticated } from '../../services/self'
import { confirmMarketplaceSubscription } from '../../services/api-catalog'
import { Link } from 'react-router-dom'

 export default class SignIn extends PureComponent {
   state = {
     isSubmitting: false,
     signedIn: false,
     errorMessage: '',
     isOpen: false,
     username: '',
     password: ''
   }
   open = () => this.setState({ isSubmitting: false, errorMessage: '', isOpen: true })
   close = () => this.setState({ isOpen: false })
   handleLogin = (event, serializedForm) => this._handleLogin(event, serializedForm)

  _handleLogin(event, serializedForm) {
    event.preventDefault()
    this.setState({isSubmitting: true})
    console.log(`EMAIL equals: ${serializedForm.email}`);
    login(this.state.username, this.state.password)
    .then(() => {
      console.log("inside Login .then() block");
      console.log(`Signin is ${this.state.signedIn}`)
         this.setState({signedIn: true, isSubmitting: false, errorMessage: ''})
         console.log(`Signin is ${this.state.signedIn}`)
         const { usagePlanId, token } = this.props

         if (usagePlanId && token) {
    	       return confirmMarketplaceSubscription(usagePlanId, token)
         }
     })
    .catch((e) => {this.setState({errorMessage: e.message, isSubmitting: false, signedIn: false})
    console.log(`After error signedIn is ${this.state.signedIn}`)
    notAuthenticated()

  })

  }

  render() {
    const { isOpen } = this.state

    return this.state.signedIn ? <Redirect to='/documentation' /> : (
      <Modal
        size='small'
        open={isOpen}
        onOpen={this.open}
        onClose={this.close}
        trigger={<a className="Signup-link" href="#">Log In</a>}
      >
        <Modal.Header>Log in</Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleLogin} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Message header='Sign Up Completed'> Username and Password are case sensitive. </Message>
            <Form.Input label='Username' name='email' onChange={ (e) => this.setState({ username: e.target.value }) }/>
            <Form.Input type='password' label='Password' name='password' autoComplete='false' onChange={ (e) => this.setState({ password: e.target.value }) }/>
            <Message header='Sign Up Completed'> <Link to="/forgotpassword"> Forgot Password </Link>  </Message>
            <Message error content={this.state.errorMessage} />
            <Modal.Actions style={{textAlign: 'right'}}>
              <Button type='button' onClick={this.close}>Close</Button>
              <Button primary type='submit'>Sign In</Button>
            </Modal.Actions>
          </Form>
        </Modal.Content>
      </Modal>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SignIn/index.js
 **/